<template>
  <!-- TODO: consider to refactor: move sidebar to specific pages -->
  <LayoutOneColumn :loading="!navStore.categoriesList.length">
    <div ref="topbar">
      <TopbarMenu :menu-list="topbarMenu">
        <template v-if="isShowEventsFilter">
          <TopbarDropdown
            :title="t('menu.events')"
            :hide-on-click="false"
            width="xl"
          >
            <VideoEventsFilter
              :items="videoStore.eventsFilterItems"
              is-scroll-view
              class="p-1"
            />
          </TopbarDropdown>
        </template>
      </TopbarMenu>
      <NuxtPage />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { ComputedRef } from 'vue'
import { useNavigation } from '~/stores/navigation'
import type { TopbarMenuInterface } from '~/models/menu'
import { useVideo } from '~/stores/video'
import { NavigationSortType } from '~/models/navigation'

const router = useRouter()
const { t } = useI18n()
const { getSortItems, fetchCategories } = useNavigation()

const navStore = useNavigation()
const videoStore = useVideo()
const topbar = ref<HTMLElement | null>(null)

const categoryMenuItems = computed(() =>
  videoStore.filters?.categories.map((category) => {
    return navStore.getCategoryFilterItem('video', category)
  })
)

onServerPrefetch(async () => {
  await fetchCategories()
  // on server we need to fetch correct filters on initial loading to avoid SSR rehydration issues
  await videoStore.fetchFilters(
    currentCategory.value ? [currentCategory.value.id] : undefined
  )
  // we have to do it here due to nuxt issue on SSR render:
  // updates made after the onServerPrefetch complete not cause rerender VideoEventsFilter component
  videoStore.setEventsFilterItemsValue(videoStore.getEventIdsFromQuery())
})

onMounted(async () => {
  // for some reason isHydrating is true here despite SSR false
  if (!useNuxtApp().isHydrating || useRuntimeConfig().public.isApp) {
    await fetchCategories()
    // we need to load filters only for single video item on client otherwise it is on VideoListPageContent.vue
    isVideoItemPage.value &&
      (await videoStore.fetchFilters(
        currentCategory.value ? [currentCategory.value.id] : undefined
      ))
  }
})

const sorts = getSortItems('video', [
  NavigationSortType.Popular,
  NavigationSortType.All,
])

const currentCategory = computed(() => {
  const category = router.currentRoute.value.params.category as string

  if (
    category &&
    Object.keys(navStore.categoriesSlugMap).length &&
    !navStore.categoriesSlugMap[category]
  ) {
    throw useCreateScreenError({
      message: `category ${category} is not found on video`,
    })
  }

  return navStore.categoriesSlugMap[category]
})

const topbarMenu: ComputedRef<TopbarMenuInterface[]> = computed(() => [
  {
    title: t('menu.all_videos'),
    items: sorts.value,
    style: 'col',
  },
  {
    title: t('common.categories'),
    items: categoryMenuItems.value || [],
    style: 'row',
    width: 'xl',
  },
])

const isVideoItemPage = computed(() =>
  router.currentRoute.value.name?.toString().includes('item-id')
)

const isShowEventsFilter = computed(() => {
  return !isVideoItemPage.value && videoStore.eventsFilterItems.length
})
</script>
